import { Box, Button } from "@mui/material";
import React from "react";
import ClearIcon from "@mui/icons-material/Clear";

const VideoPreviewComponent = ({
  VideoPreview,
  setVideoPreview,
  formik,
  videoRef,
}) => {
  const [cancel, setCancel] = React.useState(false);
  return (
    <Box className="video-preview-wrapper">
      <Button
        className="cancel-btn"
        onClick={() => {
          setVideoPreview(null);
          if (videoRef.current) {
            videoRef.current.value = null;
          }
          formik.setFieldValue("videoFile", null);
        }}
      >
        <ClearIcon sx={{ color: "white", fontSize: "25px" }} />
      </Button>
      <video
        className="video-preview"
        controls
        muted
        src={VideoPreview}
        style={{ display: cancel ? "none" : "block" }}
      />
    </Box>
  );
};

export default VideoPreviewComponent;
